import React from 'react'
import { connect } from 'react-redux'
import VersantStep1 from './VersantStep1'
import VersantStep2 from './VersantStep2'
import VersantFinalStep from './VersantFinalStep'
import VersantSelectedServices from './VersantSelectedServices'

function VersantFormStep({ activeModule, firstStepActionLabel, isDirectSaveOrg }) {
  let stepContent = <VersantStep2 />

  if (isDirectSaveOrg || activeModule === 'first') {
    stepContent = <VersantStep1 actionLabel={firstStepActionLabel} />
  } else if (activeModule === 'final') {
    stepContent = <VersantFinalStep />
  }

  return (
    <div className="row mt-7">
      <div className="col-lg-10 pr-lg-5">{stepContent}</div>
      <div className="col-lg-2 pl-lg-4">
        <VersantSelectedServices />
      </div>
    </div>
  )
}

export default connect((state) => ({
  activeModule: state.visionInsuranceClaimForm.editing.activeModule || 'first',
}))(VersantFormStep)
